exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-dashboard i.fas{position:absolute;right:10px;opacity:.075;overflow:hidden;z-index:0;font-size:24px;top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0f3d7d8","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./modules/Dashboard/Resources/assets/js/components/Totals.vue
// module id = Q5bU
// module chunks = 0